export function fullTextDate(data: Date): string {
  const opcoes: any = {
    weekday: 'long',  // Nome completo do dia da semana
    year: 'numeric',  // Ano com 4 dígitos
    month: 'long',    // Nome completo do mês
    day: 'numeric'    // Dia do mês
  };
  return data.toLocaleDateString('pt-BR', opcoes);
}

export function isValidDate(datePtBr: string): boolean {
  const dateRegex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
  const match = datePtBr.match(dateRegex);
  if (!match) return false;
  const day = parseInt(match[1], 10);
  const month = parseInt(match[2], 10);
  const year = parseInt(match[3], 10);
  if (month < 1 || month > 12) return false;
  if (day < 1 || day > 31) return false;
  const daysInMonth = new Date(year, month, 0).getDate();
  return day <= daysInMonth;
}

export function isValidTime(time: string): boolean {
  const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)(:([0-5]\d))?$/;
  return timeRegex.test(time);
}

export function isValidDateTime(dateTime: string): boolean {
  const splited = dateTime.split(' ');
  const date = splited[0];
  const time = splited[1];
  return isValidDate(date) && isValidTime(time);
}

export function formatUsDateToBr(date: string | Date | undefined): string {
  if (!date) return '';
  if (date instanceof Date) date = date.toISOString();
  return date.replace('T', ' ')
    .substring(0, 10)
    .split('-')
    .reverse()
    .join('/')
}

export function formatBrDateToUs(date: string): string {
  if (!date) return '';
  if (date.length === 10) date += ' 00:00:00';
  const data = date.replace('T', ' ').split(' ');
  const [day, month, year] = data[0].split('/');
  const time = data[1];
  return `${year}-${month}-${day}T${time}`;
}

export function formatDateTimeToInstant(dateTime: string): string {
  if (!dateTime) return '';
  const [datePart, timePart] = dateTime.split(' ');
  const dateUs = formatBrDateToUs(datePart);
  return `${dateUs}:00.000`; // sem Z para não forçar UTC
}

export function formatInstanteToDateTimeBR(instant: string | Date): string {
  if (!instant) return '';

  let date: Date;
  if (instant instanceof Date) {
    date = instant;
  } else {
    date = new Date(instant);
  }

  // Ajusta para UTC-3
  const utc = date.getTime() + date.getTimezoneOffset() * 60000;
  const brasilDate = new Date(utc - 3 * 60 * 60000);

  const datePart = brasilDate.toLocaleDateString('pt-BR');
  const timePart = brasilDate.toLocaleTimeString('pt-BR', { hour12: false });
  return `${datePart} ${timePart}`;
}

export function formatInstanteToTimeBR(instant: string | Date | undefined, showSeconds: boolean = false): string {
  if (!instant) return '';

  let date: Date;
  if (instant instanceof Date) {
    date = instant;
  } else {
    date = new Date(instant);
  }

  // Ajusta para UTC-3
  const utc = date.getTime() + date.getTimezoneOffset() * 60000;
  const brasilDate = new Date(utc - 3 * 60 * 60000);

  return showSeconds
    ? brasilDate.toTimeString().substring(0, 8)
    : brasilDate.toTimeString().substring(0, 5);
}

export function dateToUsUTC3(dateInput: Date | string): string {
  if (!dateInput) return '';

  let date: Date;
  if (dateInput instanceof Date) {
    date = dateInput;
  } else {
    date = new Date(dateInput);
  }

  // Ajusta para UTC-3
  const utc = date.getTime() + date.getTimezoneOffset() * 60000;
  const utc3 = new Date(utc - 3 * 60 * 60000);

  const pad = (n: number) => n.toString().padStart(2, '0');

  const yyyy = utc3.getFullYear();
  const mm = pad(utc3.getMonth() + 1);
  const dd = pad(utc3.getDate());
  const hh = pad(utc3.getHours());
  const min = pad(utc3.getMinutes());
  const ss = pad(utc3.getSeconds());

  return `${yyyy}-${mm}-${dd}T${hh}:${min}:${ss}.000`;
}
